// extracted by mini-css-extract-plugin
module.exports = {"mainGrid":"ReviewerDownloadPage_mainGrid__3khnp","topGrid":"ReviewerDownloadPage_topGrid__3ysLq","labelFlex":"ReviewerDownloadPage_labelFlex__1G1F3"};